import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "..";
import { envConfig } from "../../constants/config";
import { images } from "../../constants/images/images-resolved";
import { UserMetaInfo } from "../../constants/types";

interface OrgasnisationState {
  org_name: string | undefined;
  org_logo: string | undefined;
  error: boolean;
  loading: boolean;
}

// create slice

const name = "organisation";
const initialState: OrgasnisationState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const orgActions = { ...slice.actions, ...extraActions };
export const orgReducer = slice.reducer;

// implementation

function createInitialState(): OrgasnisationState {
  return {
    org_name: "",
    org_logo: "",
    error: false,
    loading: false,
  };
}

function createReducers() {
  return {
    logout,
  };

  function logout(state: OrgasnisationState) {
    state.org_name = "";
    state.org_logo = "";
  }
}

function createExtraActions() {
  return {
    getOrg: getOrg(),
  };

  function getOrg() {
    return createAsyncThunk(
      `${name}/getOrg`,
      async (a, { getState }) => {
        const state = getState() as RootState;
        return await axios.get(
          `${envConfig.BASE_URL}/organisations/${
            state.leaderboards.slug ?? "the_55_group"
          }`
        );
      } //
    );
  }
}

function createExtraReducers() {
  return {
    ...getOrg(),
  };

  function getOrg() {
    const { pending, fulfilled, rejected }: any = extraActions.getOrg;
    return {
      [pending]: (state: OrgasnisationState) => {
        state.error = false;
        state.loading = true;
      },
      [fulfilled]: (
        state: OrgasnisationState,
        action: PayloadAction<
          { data: { data: { app_icon: string; name: string } } },
          string
        >
      ) => {
        const orgdata = action.payload.data.data;
        console.log(orgdata, "ordataaa");
        state.org_name = orgdata.name ?? "Yodha";
        state.org_logo = orgdata.app_icon ?? images.yodha_logo;
        state.loading = false;
        state.error = false;
      },
      [rejected]: (state: OrgasnisationState, action: any) => {
        console.log(action, "errpr");
        state.error = true;
        state.loading = false;
      },
    };
  }
}
